// extracted by mini-css-extract-plugin
export default {"panel":"loading-modal_panel__Q-eyu","title":"loading-modal_title__UgzPk","img-container":"loading-modal_img-container__O5iFs"};